import React, { useState, useCallback, createContext } from 'react';
import uuid from 'uuid';
import Loader from './loader';

const ContextObject = {
  showLoader: () => {},
  hideLoader: () => {}
};
const LoaderContext = createContext(ContextObject);

const LoaderProvider = () => {
  const [loaderQueue, updateLoader] = useState([]);

  ContextObject.showLoader = useCallback((options = {}) => {
    const nextQueueId = uuid();

    updateLoader((prevQueue) => {
      return prevQueue.concat({ id: nextQueueId, options });
    });

    return nextQueueId;
  });

  ContextObject.hideLoader = useCallback((hideQueueId) => {
    updateLoader((prevQueue) => {
      const updateQueue = prevQueue.filter((q) => q.id !== hideQueueId);
      return updateQueue;
    });
  });

  let options = {};
  loaderQueue.forEach((q) => {
    options = { ...options, ...q.options };
  });

  return (
    <LoaderContext.Provider>
      {Boolean(loaderQueue.length) && <Loader {...options} />}
    </LoaderContext.Provider>
  );
};

export { LoaderContext, LoaderProvider };
